export function appendTruthyQueryParam<T>(
  queryParams: URLSearchParams,
  key: string & keyof T,
  obj?: T,
  keyOverride?: string,
) {
  if (!obj) {
    return
  }
  const val = obj[key]
  if (val) {
    queryParams.append(keyOverride ?? key, String(val))
  }
}
